/* Pizeta — Contact forms behavior
   - Privato/Azienda toggle with dynamic required + ARIA radiogroup keyboard nav
   - Char counter on textarea
   - Inline error display + focus first invalid
   - Modal open/close with focus trap, ESC, body lock
*/
(function () {
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function initToggle(form) {
    var group = form.querySelector('[data-pz-toggle]');
    if (!group) return;
    var opts = group.querySelectorAll('[data-pz-toggle-option]');
    var aziendaGroup = form.querySelector('[data-pz-azienda-group]');
    var typeInput = form.querySelector('input[name="body[Tipologia Utente]"]');

    function setActive(value, focus) {
      opts.forEach(function (b) {
        var on = b.getAttribute('data-pz-toggle-option') === value;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) b.focus();
      });
      if (aziendaGroup) {
        var showAzienda = value === 'Azienda';
        aziendaGroup.hidden = !showAzienda;
        aziendaGroup.querySelectorAll('input, textarea, select').forEach(function (el) {
          if (showAzienda && el.dataset.pzRequiredWhen === 'azienda') el.setAttribute('required', '');
          else el.removeAttribute('required');
          if (!showAzienda) el.value = '';
        });
      }
      if (typeInput) typeInput.value = value;
    }

    opts.forEach(function (b) {
      b.addEventListener('click', function () { setActive(b.getAttribute('data-pz-toggle-option'), false); });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var arr = Array.prototype.slice.call(opts);
        var idx = arr.indexOf(b);
        var next = e.key === 'ArrowRight' ? (idx + 1) % arr.length : (idx - 1 + arr.length) % arr.length;
        setActive(arr[next].getAttribute('data-pz-toggle-option'), true);
      });
    });

    var initial = group.getAttribute('data-pz-toggle-initial') || 'Privato';
    setActive(initial, false);
  }

  function initCounter(form) {
    form.querySelectorAll('textarea[data-pz-counter]').forEach(function (ta) {
      var max = parseInt(ta.getAttribute('maxlength'), 10) || 1000;
      var counter = form.querySelector('[data-pz-counter-for="' + ta.id + '"]');
      if (!counter) return;
      function update() {
        var n = ta.value.length;
        var left = max - n;
        var label = counter.getAttribute('data-pz-counter-label') || 'caratteri rimanenti';
        counter.textContent = left + ' ' + label;
        if (n >= max * 0.8) counter.setAttribute('data-warning', 'true');
        else counter.removeAttribute('data-warning');
      }
      ta.addEventListener('input', update);
      update();
    });
  }

  function initValidation(form) {
    // Disable native browser bubble popups — use inline custom errors only
    form.setAttribute('novalidate', '');

    // Float-label support for selects
    form.querySelectorAll('.pz-form__select').forEach(function (sel) {
      function syncEmpty() {
        if (sel.value === '' || sel.value == null) sel.setAttribute('data-empty', 'true');
        else sel.removeAttribute('data-empty');
      }
      sel.addEventListener('change', syncEmpty);
      syncEmpty();
    });

    function validate(form) {
      var invalid = [];
      form.querySelectorAll('input, textarea, select').forEach(function (el) {
        if (el.type === 'hidden' || el.disabled) return;
        var field = el.closest('.pz-form__field, .pz-form__checkbox-row');
        if (!field) return;
        var ok = el.checkValidity();
        if (ok) {
          field.removeAttribute('data-invalid');
        } else {
          field.setAttribute('data-invalid', 'true');
          invalid.push(el);
        }
      });
      return invalid;
    }

    form.addEventListener('submit', function (e) {
      var invalid = validate(form);
      if (invalid.length) {
        e.preventDefault();
        var first = invalid[0];
        if (first && first.focus) {
          try { first.focus({ preventScroll: false }); } catch (_) { first.focus(); }
          // Smooth scroll into view (respect reduced-motion)
          var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (first.scrollIntoView) first.scrollIntoView({ behavior: rm ? 'auto' : 'smooth', block: 'center' });
        }
        return;
      }
      // Popola contact[name] con "Nome Cognome" (Shopify contact form richiede name come stringa)
      var fullnameEl = form.querySelector('[data-pz-fullname]');
      var firstEl = form.querySelector('[data-pz-name-part="first"]');
      var lastEl = form.querySelector('[data-pz-name-part="last"]');
      if (fullnameEl) {
        var first = firstEl && firstEl.value ? firstEl.value.trim() : '';
        var last = lastEl && lastEl.value ? lastEl.value.trim() : '';
        fullnameEl.value = (first + ' ' + last).trim();
      }
    });

    // Clear invalid state as user fixes
    form.addEventListener('input', function (e) {
      var field = e.target.closest('.pz-form__field, .pz-form__checkbox-row');
      if (field && field.getAttribute('data-invalid') === 'true' && e.target.checkValidity && e.target.checkValidity()) {
        field.removeAttribute('data-invalid');
      }
    });
    form.addEventListener('change', function (e) {
      var field = e.target.closest('.pz-form__field, .pz-form__checkbox-row');
      if (field && field.getAttribute('data-invalid') === 'true' && e.target.checkValidity && e.target.checkValidity()) {
        field.removeAttribute('data-invalid');
      }
    });
  }

  function initForm(form) {
    if (form.__pzInit) return;
    form.__pzInit = true;
    initToggle(form);
    initCounter(form);
    initValidation(form);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.pz-form__form').forEach(initForm);
  }

  /* ── Modal controller ──────────────────────────────── */
  var modal = null;
  var lastTrigger = null;

  function trapTab(e) {
    if (!modal || e.key !== 'Tab') return;
    var nodes = Array.prototype.filter.call(modal.querySelectorAll(FOCUSABLE), function (n) {
      return !n.hidden && n.offsetParent !== null;
    });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function escClose(e) {
    if (e.key === 'Escape') closeModal();
  }

  function openModal(productTitle) {
    modal = document.getElementById('pz-form-dpt-modal');
    if (!modal) return;
    var input = modal.querySelector('[data-pz-product-name-input]');
    if (input && productTitle) {
      input.value = productTitle;
      // Trigger float-label
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    lastTrigger = document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pz-form-modal-open');
    document.addEventListener('keydown', escClose);
    document.addEventListener('keydown', trapTab);

    var close = modal.querySelector('[data-pz-modal-close]');
    if (close) setTimeout(function () { close.focus(); }, 60);
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pz-form-modal-open');
    document.removeEventListener('keydown', escClose);
    document.removeEventListener('keydown', trapTab);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    modal = null;
  }

  function initModalGlobalTriggers() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-pz-dpt-modal-open]');
      if (open) {
        e.preventDefault();
        openModal(open.getAttribute('data-product-title') || '');
        return;
      }
      var close = e.target.closest('[data-pz-modal-close]');
      if (close) {
        e.preventDefault();
        closeModal();
      }
    });
  }

  function ready() {
    initAll(document);
    initModalGlobalTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.PzForm = { openModal: openModal, closeModal: closeModal };
})();
